import React from 'react';
import { Link } from '@nackle/biw-web-router';
import {
    File,
    FileName,
    FileTriggerButton,
    FileExtractButton,
    FileRecordTable
} from '../../../loader-hatch/index';
import auth from '../../app-auth';

const FILE_TYPES = [ {
    value: 'child-budget-creation',
    text: 'Child Budget Creation'
}, {
    value: 'budget-distribution',
    text: 'Budget Distribution'
} ];


export default class FilePage extends React.Component {
    state = {
        loaded: false
    };

    render() {
        const {
            route: {
                params: {
                    fileId = ''
                } = {}
            } = {}
        } = this.props;

        return (
            <div className="page file-page">
                <div className="page-header">
                    <Link back>
                        Back
                    </Link>

                    <h1>File</h1>
                    <FileName
                        auth={ auth }
                        fileId={ fileId }
                    />

                    <FileExtractButton
                        auth={ auth }
                        fileId={ fileId }
                    />

                    <FileTriggerButton
                        auth={ auth }
                        fileId={ fileId }
                    />

                </div>

                <File
                    auth={ auth }
                    fileId={ fileId }
                    fileTypes={ FILE_TYPES }
                />
                <FileRecordTable
                    auth={ auth }
                    fileId={ fileId }
                />
            </div>
        );
    }
}
